import { action } from 'typesafe-actions';
import { IAcceptanceLedgerEntry, IApiList, ILedgerEntry } from 'types';
import { IApiQueryOptions } from '../../../api/ApiClient';
import { Ledger } from './types';

export const getPrefundLedgerRequest = (siteId: string, startDate: string, endDate: string, options?: IApiQueryOptions) => action(Ledger.GET_PREFUND_LEDGER_REQUEST, { siteId, startDate, endDate, options });
export const getPrefundLedgerSuccess = (response: IApiList<ILedgerEntry>) => action(Ledger.GET_PREFUND_LEDGER_SUCCESS, response);
export const getPrefundLedgerError = (error: any) => action(Ledger.GET_PREFUND_LEDGER_FAIL, error);

export const getAcceptanceLedgerRequest = (siteId: string, startDate: string, endDate: string, options?: IApiQueryOptions) => action(Ledger.GET_ACCEPTANCE_LEDGER_REQUEST, { siteId, startDate, endDate, options });
export const getAcceptanceLedgerSuccess = (response: IApiList<IAcceptanceLedgerEntry>) => action(Ledger.GET_ACCEPTANCE_LEDGER_SUCCESS, response);
export const getAcceptanceLedgerError = (error: any) => action(Ledger.GET_ACCEPTANCE_LEDGER_FAIL, error);
